import { useEffect, useState } from "react";

/** Heuristic: is the current visitor in the US?
 *  Priority:
 *  1. URL override `?us=1` / `?us=0` (for QA + manual self-identification).
 *  2. `lang=us-*` localStorage flag (set by the user if they want US disclosures).
 *  3. Browser timezone — America/* IANA zones (excluding Canada / Mexico / South America).
 *  4. Global Privacy Control signal (any visitor sending GPC is treated as a
 *     privacy-aware US-state resident and shown the disclosures).
 *  No external geolocation API — keeps the footer fast and dependency-free.
 *  Server-side `CF-IPCountry` improvement is tracked in PRD backlog. */
const US_TZS = new Set([
  "America/New_York", "America/Detroit", "America/Kentucky/Louisville",
  "America/Kentucky/Monticello", "America/Indiana/Indianapolis",
  "America/Indiana/Vincennes", "America/Indiana/Winamac",
  "America/Indiana/Marengo", "America/Indiana/Petersburg",
  "America/Indiana/Vevay", "America/Indiana/Tell_City",
  "America/Indiana/Knox", "America/Chicago", "America/Menominee",
  "America/North_Dakota/Center", "America/North_Dakota/New_Salem",
  "America/North_Dakota/Beulah", "America/Denver", "America/Boise",
  "America/Phoenix", "America/Los_Angeles", "America/Anchorage",
  "America/Juneau", "America/Sitka", "America/Metlakatla",
  "America/Yakutat", "America/Nome", "America/Adak", "Pacific/Honolulu",
]);

export default function useIsUSVisitor() {
  const [isUS, setIsUS] = useState(false);

  useEffect(() => {
    try {
      const sp = new URLSearchParams(window.location.search);
      const override = sp.get("us");
      if (override === "1") { setIsUS(true); return; }
      if (override === "0") { setIsUS(false); return; }

      if (navigator.globalPrivacyControl === true) { setIsUS(true); return; }

      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (tz && US_TZS.has(tz)) { setIsUS(true); return; }

      setIsUS(false);
    } catch {
      setIsUS(false);
    }
  }, []);

  return isUS;
}
